<template>
  <section>
    <filters
        ref="filters"
        :class="{active: tab === 'search'}"
        :filter-meta.sync="filterMeta"
        :filter-slug.sync="filterSlug"
        :production-types="productionTypes"
        :property-types="propertyTypes"
        :budget-range="budgetRange"
        :current-page="currentPage"
        :meta-count="metaCount"
        :meta-label="metaLabel"
        @filtersChanged="updateFiltersAndRefetch"
    ></filters>
    <div class="explore-header-area h-offset discover-header" :class="{active: tab === 'discover'}">
      <div class="inner container">
        <!-- <h2 class="align-center font-lgr wt-md">350+ locations <span class="fg-primary">&amp; counting</span></h2> -->
      </div>
    </div>
    <div class="content-panes" :class="{loading}">
      <loader :loading="loading" :fixed="true"></loader>
      <results
          :class="{active: tab === 'search'}"
          :listings="listings"
          :selected="selected"
          :current-path="currentPath"
          @navigate="changePage"
          @selectAll="selectAll"
          @selectNone="selectNone"
          @select="toggleSelect"
      ></results>
      <explore
          :class="{active: tab === 'discover'}"
      ></explore>
    </div>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import merge from 'lodash/merge'
import Explore from './Explore'
import Filters from './shared/Filters'
import Results from './Results'
import qs from 'qs'

export default {
  components: {
    Filters,
    Results,
    Explore
  },
  created () {
    this.currentPath = window.location.pathname
    this.fetch = debounce(this.fetchData, 500)

    if (this.initialListings) {
      this.listings = merge(cloneDeep(this.initialListings.paginator), { timestamp: Date.now() })

      
    }
  },
  mounted () {
    if (!this.initialListings) {
      this.fetch()
    }

    setTimeout(() => {
      this.initialized = true
    }, 800)

    this.$eventBus.$on('shortlistsLoading', loading => this.loading = loading)

    this.filters = this.$refs["filters"].filters

    // Track the initial search
    this.trackSearchViaIntercom()
  },
  props: {
    initialListings: {
      type: Object,
    },
    productionTypes: {
      type: Array,
      required: true
    },
    propertyTypes: {
      type: Array,
      required: true
    },
    budgetRange: {
      type: Array,
      required: true
    },
    filterMeta: {
      type: String,
      required: false
    },
    filterSlug: {
      type: String,
      required: false
    },
    metaCount: {
      type: Number,
    },
    metaLabel: {
      type: String,
    },
  },
  data () {
    return {
      tab: 'search',
      listings: null,
      selected: [],
      loading: !this.initialListings,
      selectedLocation: null,
      pageChanged: false,
      currentPage: (this.initialListings) ? this.initialListings.current_page : 1,
      currentPath: '/explore',
      initialized: false,

      filters: {},
    }
  },
  methods: {
    changePage (page) {
      this.pageChanged = true
      this.currentPage = page
      return this.fetch(page)
    },

    updateFiltersAndRefetch (filters) {
      this.loading = true
      if (this.initialized) {
        this.filters = filters
        this.currentPage = 1
        this.fetch(1)
      } else {
        this.filters = filters
        this.loading = false
      }
    },

    fetchData (page) {
      this.loading = true
      let filtersClone = cloneDeep(this.filters);
      filtersClone.metaCounts = JSON.stringify(filtersClone.metaCounts);
      return axios.get('/api/listings', {
        params: {
          page: page || 1,
          filters: merge({}, filtersClone, { pathFilter: this.currentPath.replace(/^\/explore\/?/, '') }),
        },
        paramsSerializer: params => qs.stringify(params)
      })
          .then(response => {
            response.data.paginator.timestamp = Date.now()
            this.listings = response.data.paginator

            if (typeof response.data.location !== 'undefined') {
              this.$eventBus.$emit('selectLocation', response.data.location.result.formatted_address)
            }

            if (this.pageChanged) {
              this.$nextTick(() => {
                let target = document.getElementById('tab-search')
                window.scrollToTarget(target)
              })
            }

            this.trackSearchViaIntercom()
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.$refs.filters.clearFilters()
              debounce(() => {
                this.fetch()
              }, 100)
            }
            this.$toasted.show('Oops! There was an issue with your search, please try again', {
              type: 'error'
            })
          })
          .then(() => {
            this.loading = false
            this.pageChanged = false
          })
    },
    selectNone () {
      this.selected = []
    },
    selectAll () {
      this.selectNone()
      for (const [key, value] of Object.entries(this.listings.data)) {
        this.selected.push(value.id)
      }
    },
    toggleSelect (listing) {
      const i = this.selected.findIndex(id => id === listing.id)
      if (i !== -1)
        return this.selected.splice(i, 1)
      this.selected.push(listing.id)
    },
    trackSearchViaIntercom () {
      // Build some search metadata for Intercom
      let search_metadata = {
        results: this.listings.total,
      }

      if (this.filters.keywords) {
        search_metadata.keywords = this.filters.keywords.join(', ')
      }

      if (this.filters.location) {
        search_metadata.location = this.filters.location_name
      }

      // Track the search
      this.$store.dispatch('intercom/track', { type: 'Search Listings', meta: search_metadata })
    }
  }
}
</script>
